import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.798 3.25H8.41c-.066 0-.105.04-.116.072l-2.539 7.446a.07.07 0 0 0-.004.038q.004.016.023.04c.028.03.07.049.126.037l4.125-.84-1.297 5.118 5.5-6.543c.019-.022.021-.036.022-.042a.1.1 0 0 0-.009-.042.1.1 0 0 0-.037-.043.13.13 0 0 0-.072-.02l-3.753-.086L12.91 3.38c.01-.019.01-.03.01-.038a.1.1 0 0 0-.014-.038c-.019-.029-.052-.053-.108-.053ZM8.41 1.75h4.388c1.166 0 2.003 1.213 1.45 2.305L12.79 6.94l1.376.032c1.31.03 2.1 1.552 1.21 2.61l-6.994 8.322a.97.97 0 0 1-1.166.248.954.954 0 0 1-.514-1.099l1.282-5.063-1.785.363c-1.18.24-2.276-.86-1.864-2.069l2.54-7.447A1.62 1.62 0 0 1 8.41 1.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLightning;
